module.exports = __webpack_public_path__ + "static/media/valorant-selector.37acf993.png";